import Select from './src/select.vue'

import type { App, Component } from 'vue'
import type { SFCWithInstall } from '@element-plus/utils'

Select.install = (app: App): void => {
  app.component(Select.name as string, Select as Component)
}

const _Select = Select as SFCWithInstall<typeof Select>

export default _Select
export const ElSelectV2 = _Select as SFCWithInstall<typeof Select>

export * from './src/token'
